export default "__VITE_ASSET__CFMR6V4F__"